<template>
  <footer id="footer">
    <div class="container">
      <div class="footer-nav">
        <Widget position="footer_menu"/>
      </div>
      <div class="copiright">
        <Widget position="copiright"/>
      </div>
    </div>
    <div class="development-us">
      <Widget position="footer_image"/>
    </div>
  </footer>
</template>

<script>
  import Widget from '@/components/app/Widget'

  export default {
    name: 'Footer',
    components: {
      Widget
    }
  }
</script>
